// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__AVDDq","choiceBoxes":"toolbarselects_choiceBoxes__31yHw","simpleField":"toolbarselects_simpleField__3VoHy"};